import Intro from "../../components/intro/Intro";
import Gallery from "../../components/gallery/Gallery";
// import Card from "../../components/card/Card";
// import { Link } from "react-router-dom";

const WoodBurning = () => {
  const woodburnings = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/britain.webp",
      alt: "a husband and wife looking at each other",
      description:
        "a friend of mine commissioned this wood burning as a christmas gift.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/cover.webp",
      alt: "wedding guest book cover",
      description: "a wedding guest book cover a friend commissioned from me.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/capone.webp",
      alt: "capone",
      description: "a wood burning i made to honor my friend's late dog.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/potter.webp",
      alt: "harry potter and voldemort",
      description:
        "i made this for fun and gave it away to a stranger on the internet.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/halo.webp",
      alt: "master chief",
      description: "this commission was one of my earliest wood burnings.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/jesus.webp",
      alt: "jesus",
      description: "i made this as a gift for a family member.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/elsa.webp",
      alt: "elsa",
      description:
        "i made this for fun and gave it away to a stranger on the internet.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/gaten.webp",
      alt: "gaten matarazzo",
      description:
        "shoutout to when 'stranger things' was big and i made this.",
    },
  ];

  return (
    <div className="main">
      <Intro
        primary="WOOD BURNING"
        secondary="i'm a professional pyrographer, which is just a fancy way of saying i'd love to burn your portrait into wood!"
      />
      <div className="column p01">
        <h2>FOR EXAMPLE</h2>
        <Gallery pictures={woodburnings} />

        <h2>COMMISSIONS OPEN</h2>
        <p className="o64">
          if you'd like to order a custom wood burning,{" "}
          <a
            className="inlink"
            href="mailto:jacob.w.moreno@gmail.com?subject=%F0%9F%94%A5%20wood%20burning"
          >
            email me at jacob.w.moreno@gmail.com
          </a>
          .
        </p>

        {/* <h2>MORE TO SHOP</h2> */}
        {/* <div className="columns_3"> */}
          {/* <Card
            primary="COLORED PAINCILS"
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/colored_paincils/preview.png",
              alt: "a row of colored pencils (from left to right: white, pink, red, orange, yellow, green, blue, purple, black) against a black background",
            }}
            button={
              <Link className="link" to="/colored-paincils">
                CHECK IT OUT
              </Link>
            }
          /> */}
          {/* <Card
            primary="WIRE NAMES"
            button={
              <Link className="link" to="/wire-names">
                GET ONE
              </Link>
            }
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/falling.png",
              alt: "wire names scattered across a black background",
            }}
          /> */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default WoodBurning;
